// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"9db57eab","235":"279f2fd5","289":"79fbfbae","330":"7b3bb2bc","471":"1c4d7e34","730":"aa701407"}[chunkId] + ".chunk.js";
};